import { useState } from "react";
import { Info } from "lucide-react";
import "./infoIcon.css"; // Import CSS file

const InfoIcon = ({ text }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="info-icon relative inline-block">
      {/* Icon Click Event */}
      <Info 
        className="w-5 h-5 text-gray-500 cursor-pointer" 
        onClick={() => setIsVisible(!isVisible)} 
      />

      {/* Tooltip - Show Only If Visible */}
      {isVisible && (
        <div className="tooltip">
          {text}
        </div>
      )}
    </div>
  );
};

export default InfoIcon;
